import { type IWixWindow } from '@wix/yoshi-flow-editor';
import { getCanonicalPostUrl } from '@wix/communities-blog-client-common';
import { type NormalizedPost } from '../types';

export const getTagListItems = (
  posts: NormalizedPost[],
  postPageSectionUrl: string,
  multilingual?: IWixWindow['multilingual'],
) => posts.map((post) => `${getCanonicalPostUrl({ post, postPageSectionUrl, multilingual })}/`);
